// extracted by mini-css-extract-plugin
export default {"diagramVmEditModal":"Edit_diagramVmEditModal__pMHeF"};